import React, { useState , useEffect } from 'react';
import bl from './bl.png';

const Bubble = ({ color }) => {
  const [position, setPosition] = useState({
    left: Math.random() * 150,
    top: Math.random() * 300,
  });

  const dynamicStyle = {
    left: `${position.left}%`,
    top: `${position.top}%`,
    backgroundColor: color,
  };

  useEffect(() => {
    const moveInterval = setInterval(() => {
      setPosition({
        left: Math.random() * 100,
        top: Math.random() * 100,
      });
    }, 3000);

    return () => clearInterval(moveInterval);
  }, []);

  return (
    <div 
      className="absolute w-2.5 h-2.5 rounded-full opacity-30 transition-all duration-[3000ms] ease-in-out z-0"
      style={dynamicStyle} 
    />
  );
};


const AcademicComponent = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const bubbleColors = ['#3B82F6', '#22C55E', '#A855F7', '#F97316'];

  const education = [
    {
      degree: "Bachelor's in Computer Science",
      institution: "ABES Institute of Technology",
      period: "2022-2026",
      status: "On-Going",
      color: "#4F46E5",
      backgroundImage: '/bl.png', // Add the path to your background image
      Score : "7.98 CGPA",
    },
    {
      degree: "Senior Secondary School (CBSE)",
      institution: "Brightland School",
      period: "2020-2022",
      status: "Completed",
      color: "#7C3AED",
      backgroundImage: 'url(/path-to-secondary-image.jpg)', // Add the path to your background image
      Score : "95.7%"
    },
    {
      degree: "High School (CBSE)",
      institution: "SGRR Public School",
      period: "2018-2020",
      status: "Completed",
      color: "#9333EA",
      backgroundImage: 'url(/path-to-highschool-image.jpg)', // Add the path to your background image
      Score : "90%",
    }
  ];

  const getDynamicCardStyles = (index, isHovered, color, backgroundImage) => ({
    background: `white ${backgroundImage || ''}`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: isHovered
      ? `0 10px 30px -10px ${color}`
      : '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    transform: isHovered ? 'scale(1.02) translateY(-5px)' : 'scale(1)',
    animation: `slideIn ${0.5 + index * 0.2}s ease-out`,
    borderColor: color,
    opacity: isHovered ? 1 : 0.9,
  });

  const getDynamicStatusStyles = (color, isHovered) => ({
    backgroundColor: isHovered ? color : '#F3F4F6',
    color: isHovered ? 'white' : color,
  });

  const getDynamicDotStyles = (color, isHovered) => ({
    backgroundColor: color,
    animation: isHovered ? 'pulse 2s infinite' : 'none',
  });

  const keyframes = `
    @keyframes slideIn {
      from {
        opacity: 0;
        transform: translateX(-30px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.5);
        opacity: 0.5;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div id='academic' className="max-w-sm sm:max-w-6xl mx-auto mt-0 sm:mt-40 mb-12 px-5 py-10 relative col-span-12 overflow-hidden">
        
          <div className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none">
            {[...Array(30)].map((_, i) => (
              <Bubble
                key={i}
                color={bubbleColors[i % bubbleColors.length]}
              />
            ))}
          </div>        

        
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-4 text-black animate-[fadeIn_0.5s_ease-out]"> Academic Journey</h2>
        <p className="mb-12 text-base text-center"> 
            Education is the passport to the future, for tomorrow belongs to those who prepare for it today.
        </p>

        <div className="relative max-w-3xl mx-auto">
          
                    {education.map((edu, index) => (
            <div
                key={index}
                className="relative w-full p-5 bg-white rounded-xl mb-8 transition-all duration-300 ease-in-out cursor-pointer border-2"
                style={getDynamicCardStyles(index, hoveredCard === index, edu.color, edu.backgroundImage)}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
            >
                <h3 className="text-base sm:text-2xl font-bold mb-2 text-gray-800">{edu.degree}</h3>
                <p className="text-xs sm:text-base text-gray-600 mb-3">{edu.institution}</p>
                <div className="flex justify-between items-center">
                <span className="text-xs sm:text-sm text-gray-500 flex items-center gap-2">
                    <span 
                      className="w-3 h-3 rounded-full inline-block mr-2"
                      style={getDynamicDotStyles(edu.color, hoveredCard === index)}
                    />
                    {edu.period}
                </span>
                <span className="text-xs sm:text-sm text-gray-500 flex items-center gap-2">
                    <span 
                      className="w-3 h-3 rounded-full inline-block mr-2"
                      style={getDynamicDotStyles(edu.color, hoveredCard === index)}
                    />
                    {edu.Score}
                </span>
                <span 
                  className="px-3 py-1 rounded-full text-xs sm:text-sm transition-all duration-300 ease-in-out"
                  style={getDynamicStatusStyles(edu.color, hoveredCard === index)}
                >
                    {edu.status}
                </span>
                </div>
            </div>
            ))}


        </div>
      </div>
    </>
  );
};

export default AcademicComponent;
